import { useOutletContext } from "react-router"
import { Helmet } from "react-helmet-async"
import { ITenant } from "../../../../../Admin/Tenants"
import { AuthLogsList } from "../../../../../AuthLogs"

export default function TenantAuthLogsPage() {
	const { tenant } = useOutletContext<{
		tenant: ITenant
		refresh: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Tenant Auth Logs</title>
			</Helmet>
			<AuthLogsList tenantUid={tenant.uid} />
		</>
	)
}
